import React, { useState } from 'react';

const box = 'w-full bg-[#F4EFE7] border border-[#1E1B18]/15 focus:border-[#8B7FB8] outline-none rounded-sm px-3 py-2 text-[13px] text-[#1E1B18]';

export const ArticleEditor = ({ a, onSave, onCancel }) => {
  const [title, setTitle] = useState(a.title);
  const [meta, setMeta] = useState(a.meta_description);
  const [excerpt, setExcerpt] = useState(a.excerpt || '');
  const [sections, setSections] = useState(a.sections.map((s) => ({ heading: s.heading, text: s.paragraphs.join('\n\n') })));
  const [saving, setSaving] = useState(false);

  const setSec = (i, k, v) => setSections(sections.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  const save = async () => {
    setSaving(true);
    const payload = {
      title, meta_description: meta, excerpt,
      sections: sections.map((s) => ({ heading: s.heading, paragraphs: s.text.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean) })),
    };
    await onSave(a.article_id, payload);
    setSaving(false);
  };

  return (
    <div data-testid={`article-editor-${a.article_id}`} className="mt-4 pt-4 border-t border-[#1E1B18]/10 space-y-3">
      <label className="block text-[11px] tracking-[0.2em] text-[#1E1B18]/55">TITLE
        <input data-testid="editor-title" className={`${box} mt-1`} value={title} onChange={(e) => setTitle(e.target.value)} /></label>
      <label className="block text-[11px] tracking-[0.2em] text-[#1E1B18]/55">GOOGLE DESCRIPTION
        <textarea data-testid="editor-meta" rows={2} className={`${box} mt-1`} value={meta} onChange={(e) => setMeta(e.target.value)} /></label>
      <label className="block text-[11px] tracking-[0.2em] text-[#1E1B18]/55">INTRO
        <textarea data-testid="editor-excerpt" rows={2} className={`${box} mt-1`} value={excerpt} onChange={(e) => setExcerpt(e.target.value)} /></label>
      {sections.map((s, i) => (
        <div key={i} className="space-y-1">
          <input data-testid={`editor-section-heading-${i}`} className={`${box} font-medium`} value={s.heading} onChange={(e) => setSec(i, 'heading', e.target.value)} />
          <textarea data-testid={`editor-section-text-${i}`} rows={6} className={box} value={s.text} onChange={(e) => setSec(i, 'text', e.target.value)} />
        </div>
      ))}
      <p className="text-[11px] text-[#1E1B18]/45">Leave a blank line between paragraphs.</p>
      <div className="flex gap-2">
        <button data-testid="editor-save-btn" onClick={save} disabled={saving}
          className="bg-[#0F0E0C] hover:bg-[#2A2622] disabled:opacity-60 text-[#F4EFE7] px-4 py-2 rounded-full text-[12px] font-medium transition-colors">{saving ? 'Saving…' : 'Save changes'}</button>
        <button data-testid="editor-cancel-btn" onClick={onCancel}
          className="border border-[#1E1B18]/20 hover:border-[#1E1B18]/50 px-4 py-2 rounded-full text-[12px] font-medium transition-colors">Cancel</button>
      </div>
    </div>
  );
};
